import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const StockVerificationList = Loadable(
  lazy(() => import("features/stockVerification/components/List")),
);
const ScanScreen = Loadable(
  lazy(() => import("features/stockVerification/components/ScanScreen")),
);
const ExceptionsGrid = Loadable(
  lazy(() => import("features/stockVerification/components/ExceptionsGrid")),
);
const ExceptionTypeMapping = Loadable(
  lazy(() => import("features/stockVerification/components/ExceptionTypeMapping")),
);
const ExceptionTypeList = Loadable(
  lazy(() => import("features/stockVerification/components/ExceptionTypeList")),
);
const ExceptionTypePage = Loadable(
  lazy(() => import("features/stockVerification/components/ExceptionTypePage")),
);

const routes = {
  path: "stock-verification",
  children: [
    { path: "", element: <StockVerificationList /> },
    { path: "verify/:id", element: <ScanScreen /> },
    { path: ":id/exceptions", element: <ExceptionsGrid /> },
    { path: "settings/exception-mapping", element: <ExceptionTypeMapping /> },
    { path: "exception-types", element: <ExceptionTypeList /> },
    { path: "exception-types/add", element: <ExceptionTypePage /> },
    { path: "exception-types/edit/:exceptionTypeID?", element: <ExceptionTypePage /> },
  ],
};

export default routes;
